<template>
  <Bar :id="chartId" :options="chartOptions" :data="chartData" />
</template>

<script>
import { Bar } from 'vue-chartjs';

import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js';

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

export default {
  name: 'BarChart',

  components: { Bar },
  props: ['data', 'chart', 'id'],

  data() {
    return {
      chartId: `chart_${this.id}`,
    };
  },

  computed: {
    chartData() {
      return {
        datasets: [
          {
            label: `${this.data.name}, ${this.$t('global.h')}.`,
            data: this.chart,
            backgroundColor: this.data.color,
          },
        ],
      };
    },
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        parsing: {
          xAxisKey: 'name',
          yAxisKey: 'value',
        },
        scales: {
          x: {
            beginAtZero: true,
          },
        },
      };
    },
  },
};
</script>
